!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define("lib", ["react", "react-dom"], t) : "object" == typeof exports ? exports.lib = t(require("react"), require("react-dom")) : e.lib = t(e.react, e["react-dom"]);
}("undefined" != typeof self ? self : this, function (e, t) {
  return function () {
    "use strict";

    var r = {
        328: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.PrintContextConsumer = t.PrintContext = void 0;
          var n = r(496),
            o = Object.prototype.hasOwnProperty.call(n, "createContext");
          t.PrintContext = o ? n.createContext({}) : null, t.PrintContextConsumer = t.PrintContext ? t.PrintContext.Consumer : function () {
            return null;
          };
        },
        428: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.ReactToPrint = void 0;
          var n = r(316),
            o = r(496),
            i = r(190),
            a = r(328),
            c = r(940),
            s = function (e) {
              function t() {
                var t = e.apply(this, n.__spreadArray([], n.__read(arguments), !1)) || this;
                return t.startPrint = function (e) {
                  var r = t.props,
                    n = r.onAfterPrint,
                    o = r.onPrintError,
                    i = r.print,
                    a = r.documentTitle;
                  setTimeout(function () {
                    var r, c;
                    if (e.contentWindow) {
                      if (e.contentWindow.focus(), i) i(e).then(function () {
                        return null == n ? void 0 : n();
                      }).then(function () {
                        return t.handleRemoveIframe();
                      }).catch(function (e) {
                        o ? o("print", e) : t.logMessages(["An error was thrown by the specified `print` function"]);
                      });else {
                        if (e.contentWindow.print) {
                          var s = null !== (c = null === (r = e.contentDocument) || void 0 === r ? void 0 : r.title) && void 0 !== c ? c : "",
                            u = e.ownerDocument.title;
                          a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = s));
                        } else t.logMessages(["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."]);
                        null == n || n(), t.handleRemoveIframe();
                      }
                    } else t.logMessages(["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"]);
                  }, 500);
                }, t.triggerPrint = function (e) {
                  var r = t.props,
                    n = r.onBeforePrint,
                    o = r.onPrintError;
                  if (n) {
                    var i = n();
                    i && "function" == typeof i.then ? i.then(function () {
                      t.startPrint(e);
                    }).catch(function (e) {
                      o && o("onBeforePrint", e);
                    }) : t.startPrint(e);
                  } else t.startPrint(e);
                }, t.handlePrint = function (e) {
                  var r = t.props,
                    o = r.bodyClass,
                    a = r.content,
                    c = r.copyStyles,
                    s = r.fonts,
                    u = r.pageStyle,
                    l = r.nonce,
                    f = "function" == typeof e ? e() : null;
                  if (f && "function" == typeof a && t.logMessages(['"react-to-print" received a `content` prop and a content param passed the callback return by `useReactToPrint. The `content` prop will be ignored.'], "warning"), f || "function" != typeof a || (f = a()), void 0 !== f) {
                    if (null !== f) {
                      var d = document.createElement("iframe");
                      d.width = "".concat(document.documentElement.clientWidth, "px"), d.height = "".concat(document.documentElement.clientHeight, "px"), d.style.position = "absolute", d.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), d.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), d.id = "printWindow", d.srcdoc = "<!DOCTYPE html>";
                      var p = (0, i.findDOMNode)(f);
                      if (p) {
                        var h = p.cloneNode(!0),
                          y = h instanceof Text,
                          b = document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"),
                          v = y ? [] : h.querySelectorAll("img"),
                          g = y ? [] : h.querySelectorAll("video"),
                          m = s ? s.length : 0;
                        t.numResourcesToLoad = b.length + v.length + g.length + m, t.resourcesLoaded = [], t.resourcesErrored = [];
                        var _ = function _(e, r) {
                          t.resourcesLoaded.includes(e) ? t.logMessages(["Tried to mark a resource that has already been handled", e], "debug") : (r ? (t.logMessages(n.__spreadArray(['"react-to-print" was unable to load a resource but will continue attempting to print the page'], n.__read(r), !1)), t.resourcesErrored.push(e)) : t.resourcesLoaded.push(e), t.resourcesLoaded.length + t.resourcesErrored.length === t.numResourcesToLoad && t.triggerPrint(d));
                        };
                        d.onload = function () {
                          var e, r, i, a;
                          d.onload = null;
                          var f = d.contentDocument || (null === (r = d.contentWindow) || void 0 === r ? void 0 : r.document);
                          if (f) {
                            f.body.appendChild(h), s && ((null === (i = d.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (a = d.contentWindow) || void 0 === a ? void 0 : a.FontFace) ? s.forEach(function (e) {
                              var t = new FontFace(e.family, e.source, {
                                weight: e.weight,
                                style: e.style
                              });
                              d.contentDocument.fonts.add(t), t.loaded.then(function () {
                                _(t);
                              }).catch(function (e) {
                                _(t, ["Failed loading the font:", t, "Load error:", e]);
                              });
                            }) : (s.forEach(function (e) {
                              return _(e);
                            }), t.logMessages(['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'])));
                            var b = "function" == typeof u ? u() : u;
                            if ("string" != typeof b) t.logMessages(['"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b, '". Styles from `pageStyle` will not be applied.')]);else {
                              var m = f.createElement("style");
                              l && (m.setAttribute("nonce", l), f.head.setAttribute("nonce", l)), m.appendChild(f.createTextNode(b)), f.head.appendChild(m);
                            }
                            if (o && (e = f.body.classList).add.apply(e, n.__spreadArray([], n.__read(o.split(" ")), !1)), !y) {
                              for (var w = y ? [] : p.querySelectorAll("canvas"), P = f.querySelectorAll("canvas"), O = 0; O < w.length; ++O) {
                                var x = w[O],
                                  S = P[O].getContext("2d");
                                S && S.drawImage(x, 0, 0);
                              }
                              var E = function E(e) {
                                var t = v[e],
                                  r = t.getAttribute("src");
                                if (r) {
                                  var n = new Image();
                                  n.onload = function () {
                                    return _(t);
                                  }, n.onerror = function (e, r, n, o, i) {
                                    return _(t, ["Error loading <img>", t, "Error", i]);
                                  }, n.src = r;
                                } else _(t, ['Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:', t]);
                              };
                              for (O = 0; O < v.length; O++) E(O);
                              var T = function T(e) {
                                var t = g[e];
                                t.preload = "auto";
                                var r = t.getAttribute("poster");
                                if (r) {
                                  var n = new Image();
                                  n.onload = function () {
                                    return _(t);
                                  }, n.onerror = function (e, n, o, i, a) {
                                    return _(t, ["Error loading video poster", r, "for video", t, "Error:", a]);
                                  }, n.src = r;
                                } else t.readyState >= 2 ? _(t) : (t.onloadeddata = function () {
                                  return _(t);
                                }, t.onerror = function (e, r, n, o, i) {
                                  return _(t, ["Error loading video", t, "Error", i]);
                                }, t.onstalled = function () {
                                  return _(t, ["Loading video stalled, skipping", t]);
                                });
                              };
                              for (O = 0; O < g.length; O++) T(O);
                              var j = "input",
                                C = p.querySelectorAll(j),
                                A = f.querySelectorAll(j);
                              for (O = 0; O < C.length; O++) A[O].value = C[O].value;
                              var k = "input[type=checkbox],input[type=radio]",
                                R = p.querySelectorAll(k),
                                M = f.querySelectorAll(k);
                              for (O = 0; O < R.length; O++) M[O].checked = R[O].checked;
                              var D = "select",
                                I = p.querySelectorAll(D),
                                q = f.querySelectorAll(D);
                              for (O = 0; O < I.length; O++) q[O].value = I[O].value;
                            }
                            if (c) for (var F = document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']"), W = function W(e, r) {
                                var n = F[e];
                                if ("style" === n.tagName.toLowerCase()) {
                                  var o = f.createElement(n.tagName),
                                    i = n.sheet;
                                  if (i) {
                                    var a = "";
                                    try {
                                      for (var c = i.cssRules.length, s = 0; s < c; ++s) "string" == typeof i.cssRules[s].cssText && (a += "".concat(i.cssRules[s].cssText, "\r\n"));
                                    } catch (e) {
                                      t.logMessages(["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.", n], "warning");
                                    }
                                    o.setAttribute("id", "react-to-print-".concat(e)), l && o.setAttribute("nonce", l), o.appendChild(f.createTextNode(a)), f.head.appendChild(o);
                                  }
                                } else if (n.getAttribute("href")) {
                                  if (n.hasAttribute("disabled")) t.logMessages(["`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:", n], "warning"), _(n);else {
                                    for (var u = f.createElement(n.tagName), d = (s = 0, n.attributes.length); s < d; ++s) {
                                      var p = n.attributes[s];
                                      p && u.setAttribute(p.nodeName, p.nodeValue || "");
                                    }
                                    u.onload = function () {
                                      return _(u);
                                    }, u.onerror = function (e, t, r, n, o) {
                                      return _(u, ["Failed to load", u, "Error:", o]);
                                    }, l && u.setAttribute("nonce", l), f.head.appendChild(u);
                                  }
                                } else t.logMessages(["`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:", n], "warning"), _(n);
                              }, L = (O = 0, F.length); O < L; ++O) W(O);
                          }
                          0 !== t.numResourcesToLoad && c || t.triggerPrint(d);
                        }, t.handleRemoveIframe(!0), document.body.appendChild(d);
                      } else t.logMessages(['"react-to-print" could not locate the DOM node corresponding with the `content` prop']);
                    } else t.logMessages(['There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.']);
                  } else t.logMessages(["To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"]);
                }, t.handleRemoveIframe = function (e) {
                  var r = t.props.removeAfterPrint;
                  if (e || r) {
                    var n = document.getElementById("printWindow");
                    n && document.body.removeChild(n);
                  }
                }, t.logMessages = function (e, r) {
                  void 0 === r && (r = "error"), t.props.suppressErrors || ("error" === r ? console.error(e) : "warning" === r ? console.warn(e) : "debug" === r && console.debug(e));
                }, t;
              }
              return n.__extends(t, e), t.prototype.handleClick = function (e, t) {
                var r = this,
                  n = this.props,
                  o = n.onBeforeGetContent,
                  i = n.onPrintError;
                if (o) {
                  var a = o();
                  a && "function" == typeof a.then ? a.then(function () {
                    return r.handlePrint(t);
                  }).catch(function (e) {
                    i && i("onBeforeGetContent", e);
                  }) : this.handlePrint(t);
                } else this.handlePrint(t);
              }, t.prototype.render = function () {
                var e = this.props,
                  t = e.children,
                  r = e.trigger;
                if (r) return o.cloneElement(r(), {
                  onClick: this.handleClick.bind(this)
                });
                if (!a.PrintContext) return this.logMessages(['"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"']), null;
                var n = {
                  handlePrint: this.handleClick.bind(this)
                };
                return o.createElement(a.PrintContext.Provider, {
                  value: n
                }, t);
              }, t.defaultProps = c.defaultProps, t;
            }(o.Component);
          t.ReactToPrint = s;
        },
        940: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.defaultProps = void 0, t.defaultProps = {
            copyStyles: !0,
            pageStyle: "\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",
            removeAfterPrint: !1,
            suppressErrors: !1
          };
        },
        892: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.useReactToPrint = void 0;
          var n = r(316),
            o = r(496),
            i = r(428),
            a = r(940),
            c = r(860),
            s = Object.prototype.hasOwnProperty.call(o, "useMemo") && Object.prototype.hasOwnProperty.call(o, "useCallback");
          t.useReactToPrint = function (e) {
            if (!s) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function () {
              throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
            };
            var t = o.useMemo(function () {
              return new i.ReactToPrint(n.__assign(n.__assign({}, a.defaultProps), e));
            }, [e]);
            return o.useCallback(function (e, r) {
              return (0, c.wrapCallbackWithArgs)(t, t.handleClick, r)(e);
            }, [t]);
          };
        },
        860: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.wrapCallbackWithArgs = void 0;
          var n = r(316);
          t.wrapCallbackWithArgs = function (e, t) {
            for (var r = [], o = 2; o < arguments.length; o++) r[o - 2] = arguments[o];
            return function () {
              for (var o = [], i = 0; i < arguments.length; i++) o[i] = arguments[i];
              return t.apply(e, n.__spreadArray(n.__spreadArray([], n.__read(o), !1), n.__read(r), !1));
            };
          };
        },
        496: function _(t) {
          t.exports = e;
        },
        190: function _(e) {
          e.exports = t;
        },
        316: function _(e, t, r) {
          r.r(t), r.d(t, {
            __addDisposableResource: function __addDisposableResource() {
              return D;
            },
            __assign: function __assign() {
              return _i;
            },
            __asyncDelegator: function __asyncDelegator() {
              return S;
            },
            __asyncGenerator: function __asyncGenerator() {
              return x;
            },
            __asyncValues: function __asyncValues() {
              return E;
            },
            __await: function __await() {
              return O;
            },
            __awaiter: function __awaiter() {
              return h;
            },
            __classPrivateFieldGet: function __classPrivateFieldGet() {
              return k;
            },
            __classPrivateFieldIn: function __classPrivateFieldIn() {
              return M;
            },
            __classPrivateFieldSet: function __classPrivateFieldSet() {
              return R;
            },
            __createBinding: function __createBinding() {
              return b;
            },
            __decorate: function __decorate() {
              return c;
            },
            __disposeResources: function __disposeResources() {
              return q;
            },
            __esDecorate: function __esDecorate() {
              return u;
            },
            __exportStar: function __exportStar() {
              return v;
            },
            __extends: function __extends() {
              return o;
            },
            __generator: function __generator() {
              return y;
            },
            __importDefault: function __importDefault() {
              return A;
            },
            __importStar: function __importStar() {
              return C;
            },
            __makeTemplateObject: function __makeTemplateObject() {
              return T;
            },
            __metadata: function __metadata() {
              return p;
            },
            __param: function __param() {
              return s;
            },
            __propKey: function __propKey() {
              return f;
            },
            __read: function __read() {
              return m;
            },
            __rest: function __rest() {
              return a;
            },
            __runInitializers: function __runInitializers() {
              return l;
            },
            __setFunctionName: function __setFunctionName() {
              return d;
            },
            __spread: function __spread() {
              return _;
            },
            __spreadArray: function __spreadArray() {
              return P;
            },
            __spreadArrays: function __spreadArrays() {
              return w;
            },
            __values: function __values() {
              return g;
            }
          });
          var _n = function n(e, t) {
            return _n = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }, _n(e, t);
          };
          function o(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function r() {
              this.constructor = e;
            }
            _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
          }
          var _i = function i() {
            return _i = Object.assign || function (e) {
              for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, _i.apply(this, arguments);
          };
          function a(e, t) {
            var r = {};
            for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
            if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
              var o = 0;
              for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
            }
            return r;
          }
          function c(e, t, r, n) {
            var o,
              i = arguments.length,
              a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
            if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);else for (var c = e.length - 1; c >= 0; c--) (o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, r, a) : o(t, r)) || a);
            return i > 3 && a && Object.defineProperty(t, r, a), a;
          }
          function s(e, t) {
            return function (r, n) {
              t(r, n, e);
            };
          }
          function u(e, t, r, n, o, i) {
            function a(e) {
              if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
              return e;
            }
            for (var c, s = n.kind, u = "getter" === s ? "get" : "setter" === s ? "set" : "value", l = !t && e ? n.static ? e : e.prototype : null, f = t || (l ? Object.getOwnPropertyDescriptor(l, n.name) : {}), d = !1, p = r.length - 1; p >= 0; p--) {
              var h = {};
              for (var y in n) h[y] = "access" === y ? {} : n[y];
              for (var y in n.access) h.access[y] = n.access[y];
              h.addInitializer = function (e) {
                if (d) throw new TypeError("Cannot add initializers after decoration has completed");
                i.push(a(e || null));
              };
              var b = (0, r[p])("accessor" === s ? {
                get: f.get,
                set: f.set
              } : f[u], h);
              if ("accessor" === s) {
                if (void 0 === b) continue;
                if (null === b || "object" != typeof b) throw new TypeError("Object expected");
                (c = a(b.get)) && (f.get = c), (c = a(b.set)) && (f.set = c), (c = a(b.init)) && o.unshift(c);
              } else (c = a(b)) && ("field" === s ? o.unshift(c) : f[u] = c);
            }
            l && Object.defineProperty(l, n.name, f), d = !0;
          }
          function l(e, t, r) {
            for (var n = arguments.length > 2, o = 0; o < t.length; o++) r = n ? t[o].call(e, r) : t[o].call(e);
            return n ? r : void 0;
          }
          function f(e) {
            return "symbol" == typeof e ? e : "".concat(e);
          }
          function d(e, t, r) {
            return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
              configurable: !0,
              value: r ? "".concat(r, " ", t) : t
            });
          }
          function p(e, t) {
            if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
          }
          function h(e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function a(e) {
                try {
                  s(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                try {
                  s(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function s(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(a, c);
              }
              s((n = n.apply(e, t || [])).next());
            });
          }
          function y(e, t) {
            var r,
              n,
              o,
              i,
              a = {
                label: 0,
                sent: function sent() {
                  if (1 & o[0]) throw o[1];
                  return o[1];
                },
                trys: [],
                ops: []
              };
            return i = {
              next: c(0),
              throw: c(1),
              return: c(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;
            function c(c) {
              return function (s) {
                return function (c) {
                  if (r) throw new TypeError("Generator is already executing.");
                  for (; i && (i = 0, c[0] && (a = 0)), a;) try {
                    if (r = 1, n && (o = 2 & c[0] ? n.return : c[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, c[1])).done) return o;
                    switch (n = 0, o && (c = [2 & c[0], o.value]), c[0]) {
                      case 0:
                      case 1:
                        o = c;
                        break;
                      case 4:
                        return a.label++, {
                          value: c[1],
                          done: !1
                        };
                      case 5:
                        a.label++, n = c[1], c = [0];
                        continue;
                      case 7:
                        c = a.ops.pop(), a.trys.pop();
                        continue;
                      default:
                        if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                          a = 0;
                          continue;
                        }
                        if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                          a.label = c[1];
                          break;
                        }
                        if (6 === c[0] && a.label < o[1]) {
                          a.label = o[1], o = c;
                          break;
                        }
                        if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(c);
                          break;
                        }
                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    c = t.call(e, a);
                  } catch (e) {
                    c = [6, e], n = 0;
                  } finally {
                    r = o = 0;
                  }
                  if (5 & c[0]) throw c[1];
                  return {
                    value: c[0] ? c[1] : void 0,
                    done: !0
                  };
                }([c, s]);
              };
            }
          }
          var b = Object.create ? function (e, t, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(t, r);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return t[r];
              }
            }), Object.defineProperty(e, n, o);
          } : function (e, t, r, n) {
            void 0 === n && (n = r), e[n] = t[r];
          };
          function v(e, t) {
            for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || b(t, e, r);
          }
          function g(e) {
            var t = "function" == typeof Symbol && Symbol.iterator,
              r = t && e[t],
              n = 0;
            if (r) return r.call(e);
            if (e && "number" == typeof e.length) return {
              next: function next() {
                return e && n >= e.length && (e = void 0), {
                  value: e && e[n++],
                  done: !e
                };
              }
            };
            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }
          function m(e, t) {
            var r = "function" == typeof Symbol && e[Symbol.iterator];
            if (!r) return e;
            var n,
              o,
              i = r.call(e),
              a = [];
            try {
              for (; (void 0 === t || t-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (e) {
              o = {
                error: e
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          }
          function _() {
            for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(m(arguments[t]));
            return e;
          }
          function w() {
            for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
            var n = Array(e),
              o = 0;
            for (t = 0; t < r; t++) for (var i = arguments[t], a = 0, c = i.length; a < c; a++, o++) n[o] = i[a];
            return n;
          }
          function P(e, t, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = t.length; o < i; o++) !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
            return e.concat(n || Array.prototype.slice.call(t));
          }
          function O(e) {
            return this instanceof O ? (this.v = e, this) : new O(e);
          }
          function x(e, t, r) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var n,
              o = r.apply(e, t || []),
              i = [];
            return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function () {
              return this;
            }, n;
            function a(e) {
              o[e] && (n[e] = function (t) {
                return new Promise(function (r, n) {
                  i.push([e, t, r, n]) > 1 || c(e, t);
                });
              });
            }
            function c(e, t) {
              try {
                (r = o[e](t)).value instanceof O ? Promise.resolve(r.value.v).then(s, u) : l(i[0][2], r);
              } catch (e) {
                l(i[0][3], e);
              }
              var r;
            }
            function s(e) {
              c("next", e);
            }
            function u(e) {
              c("throw", e);
            }
            function l(e, t) {
              e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
            }
          }
          function S(e) {
            var t, r;
            return t = {}, n("next"), n("throw", function (e) {
              throw e;
            }), n("return"), t[Symbol.iterator] = function () {
              return this;
            }, t;
            function n(n, o) {
              t[n] = e[n] ? function (t) {
                return (r = !r) ? {
                  value: O(e[n](t)),
                  done: !1
                } : o ? o(t) : t;
              } : o;
            }
          }
          function E(e) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var t,
              r = e[Symbol.asyncIterator];
            return r ? r.call(e) : (e = g(e), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function () {
              return this;
            }, t);
            function n(r) {
              t[r] = e[r] && function (t) {
                return new Promise(function (n, o) {
                  !function (e, t, r, n) {
                    Promise.resolve(n).then(function (t) {
                      e({
                        value: t,
                        done: r
                      });
                    }, t);
                  }(n, o, (t = e[r](t)).done, t.value);
                });
              };
            }
          }
          function T(e, t) {
            return Object.defineProperty ? Object.defineProperty(e, "raw", {
              value: t
            }) : e.raw = t, e;
          }
          var j = Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          };
          function C(e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && b(t, e, r);
            return j(t, e), t;
          }
          function A(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }
          function k(e, t, r, n) {
            if ("a" === r && !n) throw new TypeError("Private accessor was defined without a getter");
            if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
            return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
          }
          function R(e, t, r, n, o) {
            if ("m" === n) throw new TypeError("Private method is not writable");
            if ("a" === n && !o) throw new TypeError("Private accessor was defined without a setter");
            if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
            return "a" === n ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
          }
          function M(e, t) {
            if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
            return "function" == typeof e ? t === e : e.has(t);
          }
          function D(e, t, r) {
            if (null != t) {
              if ("object" != typeof t && "function" != typeof t) throw new TypeError("Object expected.");
              var n;
              if (r) {
                if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
                n = t[Symbol.asyncDispose];
              }
              if (void 0 === n) {
                if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
                n = t[Symbol.dispose];
              }
              if ("function" != typeof n) throw new TypeError("Object not disposable.");
              e.stack.push({
                value: t,
                dispose: n,
                async: r
              });
            } else r && e.stack.push({
              async: !0
            });
            return t;
          }
          var I = "function" == typeof SuppressedError ? SuppressedError : function (e, t, r) {
            var n = new Error(r);
            return n.name = "SuppressedError", n.error = e, n.suppressed = t, n;
          };
          function q(e) {
            function t(t) {
              e.error = e.hasError ? new I(t, e.error, "An error was suppressed during disposal.") : t, e.hasError = !0;
            }
            return function r() {
              for (; e.stack.length;) {
                var n = e.stack.pop();
                try {
                  var o = n.dispose && n.dispose.call(n.value);
                  if (n.async) return Promise.resolve(o).then(r, function (e) {
                    return t(e), r();
                  });
                } catch (e) {
                  t(e);
                }
              }
              if (e.hasError) throw e.error;
            }();
          }
          t.default = {
            __extends: o,
            __assign: _i,
            __rest: a,
            __decorate: c,
            __param: s,
            __metadata: p,
            __awaiter: h,
            __generator: y,
            __createBinding: b,
            __exportStar: v,
            __values: g,
            __read: m,
            __spread: _,
            __spreadArrays: w,
            __spreadArray: P,
            __await: O,
            __asyncGenerator: x,
            __asyncDelegator: S,
            __asyncValues: E,
            __makeTemplateObject: T,
            __importStar: C,
            __importDefault: A,
            __classPrivateFieldGet: k,
            __classPrivateFieldSet: R,
            __classPrivateFieldIn: M,
            __addDisposableResource: D,
            __disposeResources: q
          };
        }
      },
      n = {};
    function o(e) {
      var t = n[e];
      if (void 0 !== t) return t.exports;
      var i = n[e] = {
        exports: {}
      };
      return r[e](i, i.exports, o), i.exports;
    }
    o.d = function (e, t) {
      for (var r in t) o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var i = {};
    return function () {
      var e = i;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.useReactToPrint = e.ReactToPrint = e.PrintContextConsumer = void 0;
      var t = o(328);
      Object.defineProperty(e, "PrintContextConsumer", {
        enumerable: !0,
        get: function get() {
          return t.PrintContextConsumer;
        }
      });
      var r = o(428);
      Object.defineProperty(e, "ReactToPrint", {
        enumerable: !0,
        get: function get() {
          return r.ReactToPrint;
        }
      });
      var n = o(892);
      Object.defineProperty(e, "useReactToPrint", {
        enumerable: !0,
        get: function get() {
          return n.useReactToPrint;
        }
      });
      var a = o(428);
      e.default = a.ReactToPrint;
    }(), i;
  }();
});